import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { LogIn } from 'lucide-react';
import { useMerchantAuth } from '../../contexts/MerchantAuthContext';
import { toast } from 'sonner';

export default function MerchantLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useMerchantAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(email, password);
    
    if (result.success) {
      toast.success('¡Bienvenido!');
      navigate('/portal/dashboard');
    } else {
      toast.error(result.error || 'Error al iniciar sesión');
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--brand-sand))]">
      <Card className="w-full max-w-md p-8" data-testid="merchant-login-card">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[hsl(var(--brand-teal))]/10 mb-4">
            <LogIn className="w-8 h-8 text-[hsl(var(--brand-teal))]" />
          </div>
          <h1 className="text-2xl font-bold text-[hsl(var(--brand-ink))]" style={{ fontFamily: 'var(--font-heading)' }}>
            Portal de Merchants
          </h1>
          <p className="text-[hsl(var(--muted-foreground))] mt-2">
            Accede a tu panel de control
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6" data-testid="merchant-login-form">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              placeholder="tu@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              data-testid="merchant-email-input"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="password">Contraseña</Label>
            <Input
              id="password"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
              data-testid="merchant-password-input"
            />
          </div>

          <Button
            type="submit"
            className="w-full"
            disabled={loading || !email || !password}
            data-testid="merchant-login-submit-btn"
          >
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </Button>
        </form>

        <div className="mt-6 text-center">
          <p className="text-sm text-[hsl(var(--muted-foreground))]">
            ¿No tienes cuenta?{' '}
            <Link to="/portal/register" className="text-[hsl(var(--brand-teal))] hover:underline font-medium">
              Regístrate aquí
            </Link>
          </p>
        </div>

        <div className="mt-6 text-center">
          <a href="/" className="text-sm text-[hsl(var(--brand-teal))] hover:underline">
            ← Volver al sitio principal
          </a>
        </div>
      </Card>
    </div>
  );
}
